/* reformly-cc-shop-the-look.js
 *
 * <shop-the-look> — the Creator Contest video rail, verbatim from the capture's
 * shop-the-look.js, with one change: the slide list comes from a data-slides
 * attribute (JSON) so it can be edited in the theme rather than in this file.
 * The hardcoded SLIDES below stay as the fallback and as documentation of the
 * shape each slide takes.
 */
(function () {
  // ── Add a video: drop the file in videos/ and add one line here. ──────────
  //    clip = path to the file      label = shot type      sub = short subline
  var SLIDES = [
    { clip: 'videos/nrs1.webm', label: 'Lifestyle',      sub: 'With your Board at home' },
    { clip: 'videos/nrs2.webm', label: 'Setting up',     sub: 'Unfold and clip in' },
    { clip: 'videos/nrs3.webm', label: 'Workout',        sub: 'One full exercise' },
    { clip: 'videos/nrs4.webm', label: 'Movements',      sub: 'Slow, controlled reps' },
    { clip: 'videos/nrs5.webm', label: 'Close-ups',      sub: 'Carriage, rails, bands' },
    { clip: 'videos/nrs6.webm', label: 'Before & after', sub: 'Straight to camera' },
    { clip: 'videos/nrs7.webm', label: 'At home',        sub: 'Your own room, daylight' }
  ];

  var ICONS = {
    play: '<svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"></path></svg>',
    pause: '<svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"></path></svg>'
  };

  var CSS =
    ':host { display: block; }' +
    '* { box-sizing: border-box; }' +
    /* pan-y hands vertical scrolling to the browser and horizontal to us, so a
       sideways drag no longer slides the page. overscroll-behavior stops any
       chaining to the document if the track is dragged past its end. */
    '.stl-viewport { overflow: hidden; touch-action: pan-y; overscroll-behavior-x: contain; }' +
    '.stl-track { display: flex; align-items: center; gap: 14px; height: var(--tall);' +
      ' transform: translate3d(var(--shift, 0px), 0, 0);' +
      ' transition: transform 700ms cubic-bezier(0.62, 0.02, 0.2, 1); will-change: transform; }' +
    '.stl-track.is-snap { transition: none; }' +
    '.stl-card { flex: none; position: relative; overflow: hidden; width: var(--card-w); height: var(--short);' +
      ' border-radius: 14px; background: #F7F7F7 center / cover no-repeat;' +
      ' transition: height 700ms cubic-bezier(0.62, 0.02, 0.2, 1); }' +
    '.stl-track.is-snap .stl-card { transition: none; }' +
    '.stl-card.is-active { height: var(--tall); }' +
    '.stl-card video { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block;' +
      ' opacity: 0; transition: opacity 200ms cubic-bezier(0.16, 1, 0.3, 1); }' +
    '.stl-card.is-active video.is-painting { opacity: 1; }' +
    '.stl-card::after { content: ""; position: absolute; inset: 0; pointer-events: none;' +
      ' background: linear-gradient(180deg, rgba(20,20,20,0) 58%, rgba(20,20,20,0.62) 100%); }' +
    '.stl-controls { position: absolute; top: 14px; right: 14px; z-index: 2; display: none; }' +
    '.stl-card.is-active .stl-controls { display: flex; }' +
    '.stl-controls button { width: 38px; height: 38px; border: 0; border-radius: 999px; background: rgba(34,34,34,0.45);' +
      ' backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px); color: #FFFFFF; cursor: pointer;' +
      ' display: flex; align-items: center; justify-content: center;' +
      ' transition: background 140ms cubic-bezier(0.16, 1, 0.3, 1); }' +
    '.stl-controls button:hover { background: rgba(34,34,34,0.65); }' +
    '.stl-caption { position: absolute; left: 16px; right: 16px; bottom: 16px; z-index: 2; }' +
    '.stl-label { font-size: 17px; font-weight: 600; color: #FFFFFF; line-height: 1.2; letter-spacing: -0.02em;' +
      ' white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }' +
    '.stl-sub { font-size: 14px; font-weight: 400; color: rgba(255,255,255,0.75); line-height: 1.3; margin-top: 4px;' +
      ' white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }' +
    '.stl-nav { display: flex; justify-content: center; gap: 26px; margin-top: clamp(20px, 2.4vw, 30px); }' +
    '.stl-nav button { border: 0; background: transparent; padding: 0; cursor: pointer; color: #222222;' +
      ' width: 44px; height: 44px; display: flex; align-items: center; justify-content: center;' +
      ' transition: opacity 140ms cubic-bezier(0.16, 1, 0.3, 1); }' +
    '.stl-nav button:active { transform: scale(0.97); }' +
    '@media (max-width: 560px) { .stl-caption { left: 14px; right: 14px; bottom: 14px; }' +
      ' .stl-label { font-size: 16px; } .stl-sub { font-size: 13px; } .stl-nav { gap: 18px; } }' +
    '.stl-nav button:hover { opacity: 0.55; }';

  var GAP = 14, DUR = 700, COPIES = 3, NEAR = 1;
  /* Buttons keep the capture's slow 700ms ease. A finger release must not: the
     capture's curve starts almost flat, which after a flick feels like the rail
     hesitating before it moves. FLICK_* is used only for gesture settles. */
  var FLICK_DUR = 320, FLICK_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var POSTERS = {};
  var WAITING = {};
  var QUEUE = [];
  var GRABBING = false;

  // Grabs the first frame of a clip as a still, so an idle card never sits black.
  // One primer video per unique clip, one at a time, so nothing starves the decoder.
  function firstFrame(src, cb) {
    if (POSTERS[src]) { cb(POSTERS[src]); return; }
    if (WAITING[src]) { WAITING[src].push(cb); return; }
    WAITING[src] = [cb];
    QUEUE.push(src);
    pump();
  }

  function resolve(src, url) {
    if (url) POSTERS[src] = url;
    var list = WAITING[src] || [];
    delete WAITING[src];
    if (url) list.forEach(function (fn) { fn(url); });
    GRABBING = false;
    pump();
  }

  function pump() {
    if (GRABBING || !QUEUE.length) return;
    GRABBING = true;
    var src = QUEUE.shift();
    var v = document.createElement('video');
    v.muted = true; v.playsInline = true; v.preload = 'auto';
    v.style.cssText = 'position:fixed;left:-9999px;top:0;width:2px;height:2px;opacity:0;pointer-events:none';
    var done = false;
    function cleanup() {
      v.removeAttribute('src');
      v.load();
      if (v.parentNode) v.parentNode.removeChild(v);
    }
    function grab() {
      if (done || !v.videoWidth) return;
      done = true;
      clearTimeout(bail);
      var url = null;
      try {
        var c = document.createElement('canvas');
        var h = Math.min(v.videoHeight, 1280);
        var scale = h / v.videoHeight;
        c.width = Math.round(v.videoWidth * scale);
        c.height = Math.round(h);
        var ctx = c.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(v, 0, 0, c.width, c.height);
        url = c.toDataURL('image/jpeg', 0.94);
      } catch (e) { /* card keeps its flat surface */ }
      cleanup();
      resolve(src, url);
    }
    var bail = setTimeout(function () {
      if (done) return;
      done = true;
      cleanup();
      resolve(src, null);
    }, 8000);
    v.addEventListener('loadeddata', function () {
      if (v.currentTime > 0.01) grab();
      else { try { v.currentTime = 0.04; } catch (e) { grab(); } }
    });
    v.addEventListener('seeked', grab);
    v.addEventListener('error', function () {
      if (done) return;
      done = true;
      clearTimeout(bail);
      cleanup();
      resolve(src, null);
    });
    document.body.appendChild(v);
    v.src = src;
    v.load();
  }

  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      if (this._built) return;
      this._built = true;

      var root = this.attachShadow({ mode: 'open' });
      root.innerHTML =
        '<style>' + CSS + '</style>' +
        '<div class="stl-viewport"><div class="stl-track"></div></div>' +
        '<div class="stl-nav">' +
          '<button type="button" data-nav="prev" aria-label="Previous">' +
            '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"></path><path d="m11 18-6-6 6-6"></path></svg>' +
          '</button>' +
          '<button type="button" data-nav="next" aria-label="Next">' +
            '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="m13 6 6 6-6 6"></path></svg>' +
          '</button>' +
        '</div>';

      /* Slides from Liquid when supplied: [{clip,label,sub}, ...]. Falls back to
         the list at the top of this file. */
      this.slides = SLIDES;
      try {
        var raw = this.getAttribute('data-slides');
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && parsed.length) this.slides = parsed;
        }
      } catch (e) { /* keep the fallback */ }

      this.N = this.slides.length;
      this.viewport = root.querySelector('.stl-viewport');
      this.track = root.querySelector('.stl-track');
      this.cards = []; this.vids = []; this.playBtns = [];
      this.active = this.N;                 // middle copy
      this.busy = false; this.paused = false;

      for (var c = 0; c < COPIES; c++) {
        for (var i = 0; i < this.N; i++) this.addCard(this.slides[i]);
      }

      var self = this;
      root.querySelector('[data-nav="prev"]').addEventListener('click', function () { self.step(-1); });
      root.querySelector('[data-nav="next"]').addEventListener('click', function () { self.step(1); });
      var vp = this.viewport;
      /* Drag handling. What matters for smoothness:
         - write `transform` inline rather than the --shift custom property. A
           custom property feeds the transform through the cascade, so every
           change invalidates style for the whole subtree; an inline transform is
           a straight compositor update.
         - write it synchronously. touchmove is already frame-aligned on iOS, so
           deferring to requestAnimationFrame just adds a frame of latency.
         - interpolate the card heights with the same gesture, otherwise the
           magnification only animates after the finger lifts and the centre card
           appears to shrink half way through the slide.
         touch-action: pan-y (see CSS) already stops the page panning sideways,
         so the listeners stay passive and the browser keeps its fast path. */
      var drag = null;

      /* Moves the rail AND interpolates the magnification, so the centre card
         shrinks as it leaves and the incoming one grows in step with the finger.
         Without this the heights only animate after the gesture ends, which is
         the "slides large, then snaps smaller half way" jump. */
      function paintDrag(dx) {
        if (!drag) return;
        self.track.style.transform = 'translate3d(' + (drag.base + dx) + 'px, 0, 0)';

        var span = drag.m.cardW + GAP;
        var p = Math.min(Math.abs(dx) / span, 1);             // 0 = at rest, 1 = one card over
        var delta = drag.m.tall - drag.m.short;
        var dir = dx < 0 ? 1 : -1;
        var out = self.cards[self.active];
        var into = self.cards[self.active + dir];
        var other = self.cards[self.active - dir];
        if (out) out.style.height = (drag.m.tall - p * delta) + 'px';
        if (into) into.style.height = (drag.m.short + p * delta) + 'px';
        if (other) other.style.height = drag.m.short + 'px';   // reversing mid-drag
      }

      /* Settle from wherever the finger left it. Order matters:
         1. re-enable transitions (drop is-snap)
         2. let step()/layout() flip .is-active and write the new --shift
         3. only THEN drop the inline transform and heights, so each element
            animates once, from its dragged value straight to its final one.
         Clearing them first would animate everything back to the pre-drag state
         and then away again — two transitions, in opposite directions. */
      function settle(commitDir) {
        self.track.classList.remove('is-snap');

        // Retime the transition before the class flip, so the settle uses it.
        var timed = [self.track].concat(self.cards);
        timed.forEach(function (el) {
          el.style.transitionDuration = FLICK_DUR + 'ms';
          el.style.transitionTimingFunction = FLICK_EASE;
        });

        if (commitDir) self.step(commitDir, FLICK_DUR); else self.layout(true);

        // The class change is in place; hand control back and let the retimed
        // transition carry the card from its current size to the new one.
        self.track.style.transform = '';
        self.cards.forEach(function (c) { c.style.height = ''; });

        // Give the timing back to the stylesheet once this settle has finished,
        // so the arrow buttons keep their 700ms feel.
        clearTimeout(self._retime);
        self._retime = setTimeout(function () {
          timed.forEach(function (el) {
            el.style.transitionDuration = '';
            el.style.transitionTimingFunction = '';
          });
        }, FLICK_DUR + 40);
      }

      vp.addEventListener('touchstart', function (e) {
        var base = parseFloat(self.track.style.getPropertyValue('--shift')) || 0;
        drag = { x: e.touches[0].clientX, y: e.touches[0].clientY, base: base, moved: false,
                 m: self.metrics() };
      }, { passive: true });

      vp.addEventListener('touchmove', function (e) {
        if (!drag) return;
        var dx = e.touches[0].clientX - drag.x;
        var dy = e.touches[0].clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }   // vertical: let it scroll
          if (Math.abs(dx) < 8) return;
          drag.moved = true;
          /* is-snap kills the transition on the track *and* the cards, so both
             follow the finger instead of easing towards a stale target. */
          self.track.classList.add('is-snap');
        }
        paintDrag(dx);
      }, { passive: true });

      vp.addEventListener('touchend', function (e) {
        if (!drag) return;
        var dx = e.changedTouches[0].clientX - drag.x;
        var moved = drag.moved;
        drag = null;
        if (!moved) return;
        if (Math.abs(dx) > 34) {
          self._swiped = Date.now();
          settle(dx < 0 ? 1 : -1);
        } else {
          settle(0);                          // too short to count: ease back
        }
      }, { passive: true });

      vp.addEventListener('touchcancel', function () {
        if (!drag) return;
        drag = null;
        settle(0);
      }, { passive: true });

      this._onResize = function () { self.layout(false); };
      window.addEventListener('resize', this._onResize);

      this.layout(false);
      this.loadNear();
      this.sync();
      var self2 = this;
      var kick = function () {
        if (self2._grabbed) return;
        self2._grabbed = true;
        self2.grabPosters();
      };
      var v0 = this.vids[this.active];
      if (v0) v0.addEventListener('playing', kick, { once: true });
      setTimeout(kick, 4000);
      // a hidden tab throttles media decoding — retry the stills once it's visible again
      this._onVisible = function () {
        if (document.hidden) return;
        self2._grabbed = false;
        self2.grabPosters();
        self2.loadNear();
        self2.sync();
      };
      document.addEventListener('visibilitychange', this._onVisible);
    }

    grabPosters() {
      var self = this;
      this.slides.forEach(function (s) {
        /* An explicit poster skips the first-frame grab entirely — which also
           sidesteps the canvas being tainted when the clip is cross-origin
           (Shopify's CDN is a different origin from the storefront). */
        if (s.poster) {
          self.cards.forEach(function (card) {
            if (card.dataset.clip === s.clip) card.style.backgroundImage = 'url("' + s.poster + '")';
          });
          return;
        }
        if (POSTERS[s.clip]) {
          self.cards.forEach(function (card) {
            if (card.dataset.clip === s.clip) card.style.backgroundImage = 'url("' + POSTERS[s.clip] + '")';
          });
          return;
        }
        firstFrame(s.clip, function (url) {
          self.cards.forEach(function (card) {
            if (card.dataset.clip === s.clip) card.style.backgroundImage = 'url("' + url + '")';
          });
        });
      });
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      clearInterval(this.autoTimer);
      clearTimeout(this.stepTimer);
      if (this._onVisible) document.removeEventListener('visibilitychange', this._onVisible);
    }

    addCard(s) {
      var card = document.createElement('div');
      card.className = 'stl-card';
      card.innerHTML =
        '<video muted playsinline preload="auto"></video>' +
        '<div class="stl-controls">' +
          '<button type="button" data-role="play" aria-label="Pause">' + ICONS.pause + '</button>' +
        '</div>' +
        '<div class="stl-caption">' +
          '<div class="stl-label">' + s.label + '</div>' +
          '<div class="stl-sub">' + s.sub + '</div>' +
        '</div>';
      var self = this;
      var vid = card.querySelector('video');
      vid.dataset.clip = s.clip;
      var reveal = function () { vid.classList.add('is-painting'); };
      vid.addEventListener('playing', reveal);
      vid.addEventListener('seeked', reveal);
      vid.addEventListener('timeupdate', function () {
        if (vid.currentTime > 0.02) reveal();
      });
      vid.addEventListener('ended', function () {
        var mine = self.cards.indexOf(card);
        if (mine === self.active && !self.paused) self.step(1);
        try { vid.currentTime = 0; } catch (e) {}
      });
      var btn = card.querySelector('[data-role="play"]');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        self.paused = !self.paused;
        self.sync();
      });
      card.addEventListener('click', function () {
        if (self._swiped && Date.now() - self._swiped < 400) return;
        var i = self.cards.indexOf(card);
        if (i !== self.active) self.step(i - self.active);
      });
      card.dataset.clip = s.clip;
      this.track.appendChild(card);
      this.cards.push(card);
      this.vids.push(vid);
      this.playBtns.push(btn);
    }

    metrics() {
      var vw = this.viewport.clientWidth || this.clientWidth || window.innerWidth;
      var phone = vw < 560;
      var cardW = Math.round(Math.max(150, Math.min(300, phone ? vw * 0.64 : vw * 0.21)));
      var tall = Math.round(cardW * 16 / 9);
      return { vw: vw, cardW: cardW, tall: tall, short: Math.round(tall * 0.8) };
    }

    layout(smooth) {
      var m = this.metrics();
      this.track.style.setProperty('--card-w', m.cardW + 'px');
      this.track.style.setProperty('--tall', m.tall + 'px');
      this.track.style.setProperty('--short', m.short + 'px');

      if (!smooth) this.track.classList.add('is-snap');
      var shift = Math.round(m.vw / 2 - m.cardW / 2 - this.active * (m.cardW + GAP));
      this.track.style.setProperty('--shift', shift + 'px');

      var self = this;
      this.cards.forEach(function (card, i) { card.classList.toggle('is-active', i === self.active); });

      if (!smooth) {
        void this.track.offsetHeight;
        var t = this.track;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { t.classList.remove('is-snap'); });
        });
      }
    }

    // give every card near the centre a real source and a painted first frame
    loadNear() {
      var self = this;
      this.vids.forEach(function (v, i) {
        var near = Math.abs(i - self.active) <= NEAR;
        var has = !!v.getAttribute('src');
        if (near && !has) {
          v.setAttribute('src', v.dataset.clip);
          v.load();
        } else if (!near && has) {
          // free the connection — the card falls back to its still
          v.classList.remove('is-painting');
          v.pause();
          v.removeAttribute('src');
          v.load();
        }
      });
    }

    sync() {
      var self = this;
      this.playBtns.forEach(function (b) {
        b.innerHTML = self.paused ? ICONS.play : ICONS.pause;
        b.setAttribute('aria-label', self.paused ? 'Play' : 'Pause');
      });
      this.vids.forEach(function (v, i) {
        v.muted = true;
        if (i === self.active) {
          if (self.paused) v.pause();
          else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else {
          if (!v.paused) v.pause();
          v.classList.remove('is-painting');
          if (v.currentTime !== 0 && v.readyState >= 1) { try { v.currentTime = 0; } catch (e) {} }
        }
      });
      this.armAuto();
    }

    armAuto() {
      var self = this;
      clearInterval(this.autoTimer);
      this.autoTimer = setInterval(function () {
        if (self.paused || self.busy || document.hidden) return;
        var v = self.vids[self.active];
        // the clip's own end drives the rail; the timer only covers unplayable clips
        if (!v || v.readyState < 2 || v.paused) self.step(1);
      }, 5200);
    }

    step(dir, dur) {
      if (this.busy || !dir) return;
      var lock = (dur || DUR) + 40;
      this.busy = true;
      this.paused = false;
      this.active += dir;
      this.layout(true);
      this.loadNear();
      this.sync();

      var self = this;
      clearTimeout(this.stepTimer);
      this.stepTimer = setTimeout(function () {
        // keep the index inside the middle copy, invisibly
        var a = self.active;
        if (a < self.N || a >= 2 * self.N) {
          self.active = ((a % self.N) + self.N) % self.N + self.N;
          self.layout(false);
          self.loadNear();
          self.sync();
        }
        self.busy = false;
      }, lock);
    }
  }

  if (!customElements.get('shop-the-look')) customElements.define('shop-the-look', ShopTheLook);
})();
